import { Store } from "pullstate";

export const CTCStore = new Store( {
    countries: [],
    modalAddCountry: false

} );